// extracted by mini-css-extract-plugin
export default {"component":"Checkout__component-TaT7","section":"Checkout__section-QZRy","logoBuyer":"Checkout__logoBuyer-oW9c","buyerName":"Checkout__buyerName-_2Cg"};